import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    template
})
export default class {
    constructor ($scope, $translate, $stateParams, lodash, toastr, DATATABLES, ListFactory, QuestionResource, ModalService, QuestionRouteService, QuestionService) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.QuestionRouteService = QuestionRouteService;
        this.QuestionService = QuestionService;

        this.defaultQuery = { noPool: true, expand: 'category,author,questionI18ns,activeI18n,formQuestions' };

        this.filter = lodash.assign({}, this.defaultQuery, $stateParams);
        this.list = ListFactory.createWithPagination(QuestionResource.query.bind(QuestionResource));

        this.list.pagination.currentPage = $stateParams.page ? $stateParams.page : 1;
        this.list.sort = $stateParams.sort ? $stateParams.sort : null;

        this.list.fetch(this.filter);

        $scope.$on('questionIsAdded', () => {
            this.list.fetch(this.filter);
        });
    }

    delete (question) {
        this.QuestionService.delete(question).then(() => {
            this.list.fetch(this.filter);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/poolless/list/index.js